import { render, staticRenderFns } from "./LeaderboardDialog.vue?vue&type=template&id=1900be70"
import script from "./LeaderboardDialog.vue?vue&type=script&lang=js"
export * from "./LeaderboardDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports